var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 344.67 305.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5261f8;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-3{fill:#f9d479;}.cls-4,.cls-5,.cls-6{fill:#5261f8;}.cls-4,.cls-7,.cls-8,.cls-9,.cls-10{font-size:16.26px;}.cls-4,.cls-8,.cls-9,.cls-10{font-family:Roboto-Bold, Roboto;font-weight:700;}.cls-11{letter-spacing:-.06em;}.cls-5,.cls-7,.cls-12{font-family:Roboto-Regular, Roboto;}.cls-5,.cls-12{font-size:11.5px;}.cls-13{fill:#ff7990;}.cls-7,.cls-9,.cls-10{fill:#292a46;}.cls-14{letter-spacing:-.02em;}.cls-8,.cls-12{fill:#f6f7fb;}.cls-10{letter-spacing:-.03em;}.cls-2{fill:lime;stroke:#f6f7fb;stroke-width:.57px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 2.36,
    width: 45.93,
    height: 66.93,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(17.5 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(13.88 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FRI")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 49.71,
    y: 2.36,
    width: 45.93,
    height: 66.93,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(67.21 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(61.75 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 6.82,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 13.6,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 99.41,
    y: 2.36,
    width: 45.93,
    height: 66.93,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(116.91 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(110.34 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SUN")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 141,
    cy: 4.22,
    r: 3.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.12,
    y: 2.36,
    width: 45.93,
    height: 47.4,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(166.62 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(158.21 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MON")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.83,
    y: 2.36,
    width: 45.93,
    height: 47.4,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(216.33 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(210.57 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TUE")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 248.53,
    y: 2.36,
    width: 45.93,
    height: 47.4,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(266.03 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(258.56 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "WED")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 298.24,
    y: 2.36,
    width: 45.93,
    height: 47.4,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(315.74 20.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(13.03 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(62.74 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(117.01 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(166.72 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(216.43 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(266.13 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(315.84 132.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(15.04 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(67.08 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(114.47 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(160.51 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TH")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(216.54 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(265.7 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(310.05 102.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SU")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(309.15 33.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "THU")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 12.4,
    y: 43.64,
    width: 21.13,
    height: 6.13,
    rx: 1.53,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.65,
    y: 43.64,
    width: 21.13,
    height: 6.13,
    rx: 1.53,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.4,
    y: 51.74,
    width: 21.13,
    height: 6.13,
    rx: 1.53,
    ry: 1.53,
    transform: "translate(45.93 109.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 20.1,
    y: 135.07,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.1,
    y: 140.5,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06,
    transform: "translate(44.33 285.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 120.31,
    y: 135.07,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 120.31,
    y: 140.5,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06,
    transform: "translate(244.76 285.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(17.6 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(67.3 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(117.01 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(166.72 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(211.86 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(261.57 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(311.27 175.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 68.15,
    y: 135.73,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.15,
    y: 141.16,
    width: 4.13,
    height: 4.11,
    rx: 2.06,
    ry: 2.06,
    transform: "translate(140.43 286.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(13.03 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(62.74 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "14")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(112.45 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(162.15 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(211.86 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(261.57 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(311.27 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(13.03 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(62.74 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(112.45 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(162.15 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(211.86 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(261.57 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(311.27 261.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "26")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(13.03 301.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(62.74 301.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(112.45 301.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "29")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(162.15 301.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(211.86 301.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "31")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.ad72477aea0aa3939fcdc4b673148f8f.svg";
export { ForwardRef as ReactComponent };